export default __webpack_public_path__ + "static/media/5.630464c8.jpg";